import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';

// Blocks access to paid features if user has no active subscription.
// Allows: trialing, active, past_due (grace)
// Blocks: no subscription status / canceled
const ACTIVE_STATUSES = new Set(['trialing', 'active', 'past_due']);
const ADMIN_EMAIL = 'chiragahir@gmail.com';

const SubscriptionGate = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [hasSubscription, setHasSubscription] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!user) { setChecking(false); return; }
      // Admin bypass - keep full access for founder
      if (user.email === ADMIN_EMAIL || user.isAdmin) {
        setHasSubscription(true);
        setChecking(false);
        return;
      }
      try {
        const { data } = await api.get('/billing/usage');
        setHasSubscription(ACTIVE_STATUSES.has(data.subscriptionStatus));
      } catch {
        setHasSubscription(false);
      } finally {
        setChecking(false);
      }
    };
    if (!loading) check();
  }, [user, loading]);

  if (loading || checking) {
    return <div className="min-h-screen flex items-center justify-center bg-[#fdfaf6] text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!hasSubscription) return <Navigate to="/choose-plan" replace state={{ from: location.pathname }} />;
  return children;
};

export default SubscriptionGate;
